module.exports = __webpack_public_path__ + "img/Yape_qr.55332c45.jpg";